// extracted by mini-css-extract-plugin
export default {"errorStack":"MessageStack_errorStack__3Q4yD"};